import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filters" }
const _hoisted_2 = {
  class: "form",
  id: "statistic-form"
}
const _hoisted_3 = { class: "form-block form-block--25" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "form-block form-block--25" }
const _hoisted_6 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_7 = { class: "form-block form-block--25" }
const _hoisted_8 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_9 = { class: "form-block form-block--25" }
const _hoisted_10 = { class: "form__controls" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { class: "popup__content" }
const _hoisted_14 = { style: {"overflow":"auto"} }
const _hoisted_15 = {
  class: "table table-striped",
  style: {"position":"relative"}
}
const _hoisted_16 = { class: "text-start p-sm" }
const _hoisted_17 = { class: "text-start p-sm" }
const _hoisted_18 = { class: "text-start p-sm" }
const _hoisted_19 = { class: "text-start p-sm" }
const _hoisted_20 = { class: "text-start p-sm" }
const _hoisted_21 = { class: "text-start p-sm" }
const _hoisted_22 = { class: "p ps" }
const _hoisted_23 = { class: "p" }
const _hoisted_24 = { class: "p" }
const _hoisted_25 = { class: "p" }
const _hoisted_26 = { class: "p" }
const _hoisted_27 = { class: "p" }
const _hoisted_28 = { class: "text-end p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup__lg",
    title: _ctx.$t('menu.items.accountOperations'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: _ctx.helper.trans('labels.invoice_id'),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.dealId) = $event))
            }, null, 8, _hoisted_4), [
              [_vModelText, _ctx.requestDTO.dealId]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DatePicker, {
              modelValue: _ctx.requestDTO.fromDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
              mode: "dateTime",
              "model-modifiers": {string: true},
              is24hr: "",
              masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
            }, {
              default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                _createElementVNode("input", {
                  class: "form-control form-control-sm",
                  placeholder: _ctx.helper.trans('labels.from_date'),
                  value: inputValue,
                  onFocus: togglePopover,
                  onChange: inputEvents.change
                }, null, 40, _hoisted_6)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DatePicker, {
              modelValue: _ctx.requestDTO.toDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
              mode: "dateTime",
              "model-modifiers": {string: true},
              is24hr: "",
              masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
            }, {
              default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                _createElementVNode("input", {
                  class: "form-control form-control-sm",
                  placeholder: _ctx.helper.trans('labels.to_date'),
                  value: inputValue,
                  onFocus: togglePopover,
                  onChange: inputEvents.change
                }, null, 40, _hoisted_8)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Multiselect, {
              id: "types",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.types,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.types) = $event)),
              options: Object.values(_ctx.OperationType),
              "custom-label": (opt) => _ctx.helper.trans(`operation_type.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.type')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.applyFilters,
              class: "form__btn btn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('button.apply')), 1)
              ]),
              _: 1
            }, 8, ["on-click"]),
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.clearFilters,
              class: "form__btn form__btn--reset btn btn--2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('button.reset')), 1)
              ]),
              _: 1
            }, 8, ["on-click"])
          ])
        ])
      ]),
      _createVNode(_component_LoaderContent, {
        ref: "loader",
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("table", _hoisted_15, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.balance_before')), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.balance_after')), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("th", { class: "text-start p-sm" }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations.items, (operation) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: operation.id
                    }, [
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.dateHelper.format(operation.createdAt)), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(operation.currency), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(operation.transactionType === _ctx.TransactionType.CREDIT ? "+" : '-') + _toDisplayString(_ctx.numberFormatter.formatNumber(operation.sum)), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$t(`operation_type.${operation.operationType}`)), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.numberFormatter.formatNumber(operation.balanceBefore)), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.numberFormatter.formatNumber(operation.balanceAfter)), 1),
                      _createElementVNode("td", _hoisted_28, [
                        _createElementVNode("button", {
                          style: {"display":"none"},
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = () => {}),
                          class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                        }, [
                          _createVNode(_component_SvgIcon, { icon: "details" })
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              (_ctx.operations.totalCount > _ctx.operations.items.length)
                ? (_openBlock(), _createBlock(_component_b_pagination, {
                    key: 0,
                    modelValue: _ctx.page,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page) = $event)),
                      _cache[6] || (_cache[6] = ($event: any) => (_ctx.load()))
                    ],
                    "total-rows": _ctx.operations.totalCount,
                    "per-page": _ctx.operations.limit,
                    limit: 20,
                    "prev-text": "Back",
                    "next-text": "Next",
                    align: "start",
                    "first-number": "",
                    "hide-goto-end-buttons": "",
                    "hide-ellipsis": ""
                  }, null, 8, ["modelValue", "total-rows", "per-page"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}